import { MsalService } from '@azure/msal-angular';
import { ProfileManagerService } from './../../../../custom-shared/services/profile-manager.service';
import { SharedVariable } from './../../../../custom-shared/util/shared-variable';
import { isNgTemplate } from '@angular/compiler';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoService } from '@app/core/services/crypto/crypto.service';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { AppScreenUtil } from '@app/custom-shared/util/app-screen-util';
import { ScreenComponent } from '@core/features/screen.component';
import { environment } from '@env/environment';
import * as fromMaster from '@features/master/create-user/store';
import { Store } from '@ngrx/store';
import { FeatureService } from '@services/feature/feature.service';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { MasterConfirmedMessageComponent } from '../../confirmed-message/master-confirmed-message.component';
import { MasterCreateUserService } from '../../create-user/master-create-user.service';
import { UserPost } from '../cliente-editar-usuario/cliente-editar-usuario.model';
import { InvestmentGroup } from '../cliente-grupo-investimento/cliente-grupo-investimento.model';
import { MasterClienteCreateUserService } from './master-cliente-create-user.service';

const BASE_PATH = environment.basePath;
enum Status {
  novoUsuario = 'Novo usuário',
}

enum Language {
  portugues = 'português',
  ingles = 'inglês',
}

enum Nationality {
  residente = 'residente',
  estrangeiro = 'estrangeiro',
}

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-create-user',
  templateUrl: './master-cliente-create-user.component.html',
  styleUrls: ['./master-cliente-create-user.component.scss'],
})
export class MasterClienteCreateUserComponent extends ScreenComponent
  implements OnInit, AfterViewInit, OnDestroy {
  vars: any = {};
  loading$: Observable<boolean>;
  data$: Observable<any>;
  ddiValues$: Observable<any>;
  nationalityValues$: Observable<any>;
  statusValues$: Observable<any>;
  languageValues$: Observable<any>;
  isValidatedBycpfservice: boolean = false

  statusInitialOption = 'Novo usuário';
  statusOptions = [{ label: 'Novo usuário', value: 'Novo usuário' }];
  hasSelectedGroups = false;
  form2: FormGroup;
  form3: FormGroup;
  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper;
  customErrorMessage: string = null;
  isValidateByEmail: boolean = false;
  isResident: boolean;

  /**
   * Default Constructor of the component
   */
  constructor(
    private createUserService: MasterClienteCreateUserService,
    private snackBarService: DialogBoxService,
    private featureService: FeatureService,
    private cryptoService: CryptoService,
    public dialogRef: MatDialogRef<MasterClienteCreateUserComponent>,
    private dialog: MatDialog,
    router: Router,
    store: Store<fromMaster.State>,
    activeRoute: ActivatedRoute,
    private shared: SharedVariable,
    private msalService: MsalService,
    private profileService: ProfileManagerService,
  ) {
    super(activeRoute, store, router);

    // Criação dos formularios de criar usuario
    this.form = this.createForm();
    this.form2 = this.createForm2();
    this.form3 = this.createForm3();
  }
  ngAfterViewInit(): void { }

  ngOnInit() {
    super.ngOnInit();
    this.initializeFormValues();
  }

  initializeFormValues() {
    this.form.get('status').setValue(this.statusInitialOption);
    this.form.get('language').setValue(Language.portugues);
    this.form.get('nationality').setValue(Nationality.residente);
  }

  /**
   * Initialize the component by the provided data object
   * @param item
   */
  init() { }

  validateRadioButton(): void {
    if (this.islblCpfVisible()) {
      this.form.controls['cpf'].markAsTouched({ onlySelf: true });
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.isResident = true
    }

    if (this.ispassportnumberVisible()) {
      this.form.controls['passport'].markAsTouched({ onlySelf: true });
    }

    if (this.islblRgVisible()) {
      this.form.controls['rg'].markAsTouched({ onlySelf: true });
    }

  }

  /// Valida recursivamente todos os campos do form1(form)
  validateForm1(formGroup: FormGroup | FormArray): boolean {
    let isInvalid = this.form.invalid;

    if (isInvalid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateForm1(control);
        }
      });
    }
    return !isInvalid;
  }
  getStatusValues(): Observable<any> {
    return (this.statusValues$ =
      this.statusValues$ ||
      this.featureService.translatorService.enumValues(Status, 'Status'));
  }

  validateAndGoToStep2() {
    let body = {}
    if (this.form.get('userSso').value != null && this.form.get('userSso').value !="") {
      if(this.form.get('nationality').value == "residente"){
      if (this.form.get('cpf').value) {
        let cpf = this.form.get('cpf').value
            cpf = cpf.replaceAll('.','')
            cpf = cpf.replaceAll('-','')
            cpf = cpf.replaceAll('_','')
             body = {
              // "login": this.msalService.instance.getAllAccounts()[0].name,
              "login": this.shared.userSso,
              "name": this.form.get('userSso').value,
              "cpf": cpf,
            }
      }
      this.createUserService.consultUserSSO(body).subscribe(res => {
      if (Number(res.result) < 100) {
        if (this.validateForm1(null)) {
          this.goToStep(1); // vai para o step 2
        }
      } else {
        setTimeout(() => {
          this.snackBarService.snackbarUtil.showError(
            res.messag,
          );
        }, 1500)
      }
    })
    }else {
      if (this.validateForm1(null)  && this.isValidateByEmail == true) {
      this.goToStep(1); // vai para o step
   }
  }
    } else {
        if (this.validateForm1(null)  && this.isValidateByEmail == true) {
        this.goToStep(1); // vai para o step
    }
    }

  }

  /// Avança um step da tela
  onNext(): void {
    this.stepper.next();
    AppScreenUtil.scrollModalToTop();
  }

  /// Retorna um step da tela
  onPrevious(): void {
    this.stepper.previous();
    AppScreenUtil.scrollModalToTop();
  }

  /// Muda para um step específico
  goToStep(index: number): void {
    this.stepper.selectedIndex = index;
    AppScreenUtil.scrollModalToTop();
  }

  getStepOneIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-1';
    if (this.stepper.selectedIndex == 1 || this.stepper.selectedIndex == 2)
      return 'icon-step-check';
  }

  getStepTwoIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-2 icon-step-disable ';
    if (this.stepper.selectedIndex == 1) return 'icon-step-2';
    if (this.stepper.selectedIndex == 2) return 'icon-step-check';
  }
  getStepThreeIcon(): string {
    if (
      this.stepper == null ||
      this.stepper.selectedIndex == 0 ||
      this.stepper.selectedIndex == 1
    )
      return 'icon-step-3 icon-step-disable ';
    if (this.stepper.selectedIndex == 2) return 'icon-step-3';
  }

  getProgressBarValue(): number {
    if (this.stepper == null) return 33.33;

    if (this.stepper.selectedIndex == 0) return 33.33;
    if (this.stepper.selectedIndex == 1) return 66.66;
    if (this.stepper.selectedIndex == 2) return 100;
  }

  createForm(): FormGroup {
    return this.featureService.formBuilder.group({
      nationality: [null, []],
      cpf: [null, []],
      passport: [null, []],
      name: [null, [Validators.maxLength(50), this.notOnlyWhitespace]],
      userSso: [null, [Validators.maxLength(50)]],
      login: [
        null,
        [
          Validators.required,
          Validators.email
        ],
      ],
      status: [Status.novoUsuario, []],
      language: [null, []],
    });
  }

   notOnlyWhitespace (control: FormControl) {
    if (!control.value || control.value.trim().length === 0) {
      return { notOnlyWhitespace: true };
    } else {
      return null;
    }
  }

  createForm2(): FormGroup {
    return this.featureService.formBuilder.group({
      profileId: [null, [Validators.required]],
    });
  }

  createForm3(): FormGroup {
    return this.featureService.formBuilder.group({
      investmentGroups: [null, [Validators.required]],
    });
  }

  getNationalityValues(): Observable<any> {
    return (this.nationalityValues$ =
      this.nationalityValues$ ||
      this.featureService.translatorService.enumValues(
        Nationality,
        'Nationality',
      ));
  }

  getLanguageValues(): Observable<any> {
    return (this.languageValues$ =
      this.languageValues$ ||
      this.featureService.translatorService.enumValues(Language, 'Language'));
  }

  getClientsGroup() {
    return this.featureService.formBuilder.group({
      name: [null, []],
    });
  }

  islblCpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality != 'estrangeiro';
  }

  iscpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality != 'estrangeiro';
    if (result !== true) {
      this.form.get('cpf').clearValidators();
      this.form.get('cpf').updateValueAndValidity();
    } else {
      this.form.get('cpf').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportnumberVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality == 'estrangeiro';
  }

  ispassportVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality == 'estrangeiro';
    if (result !== true) {
      this.form.get('passport').clearValidators();
      this.form.get('passport').updateValueAndValidity();
    } else {
      this.form.get('passport').setValidators([]);
    }
    return result;
  }

  islblRgVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality != 'estrangeiro';
  }

  isrgVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality != 'estrangeiro';
    if (result !== true) {
      this.form.get('rg').clearValidators();
      this.form.get('rg').updateValueAndValidity();
    } else {
      this.form.get('rg').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportRequired(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality == 'estrangeiro';
    if (result) {
      this.form.get('passport').setValidators([Validators.required]);
    }
    return result;
  }

  islanguageReadOnly(): boolean {
    const language =
      get(this.form.value, 'language') || get(this.data, 'language');
    return language == 'português';
  }

  cpfMaskfn() {
    return [
      /[0-9]/,
      /\d/,
      /\d/,
      '.',
      /[0-9]/,
      /\d/,
      /\d/,
      '.',
      /[0-9]/,
      /\d/,
      /\d/,
      '-',
      /[0-9]/,
      /\d/,
    ];
  }
  checkEmail(param) {
    this.form.get('login').setValue(this.form.get('login').value.toLowerCase());
    console.log(param)
    this.createUserService.CheckEmail(param).subscribe(res => {
      console.log("check", res)
      if (res != true) {
        if (this.form.controls.login.invalid) {
          this.form.controls['login'].setErrors({ invalid: true });
          this.isValidateByEmail = false
          return { invalid: true };
        }
    
        this.form.controls['login'].setErrors(null);
        this.isValidateByEmail = true
        return { invalid: false };
      } else {
        this.form.controls['login'].setErrors({ invalid: true });
        this.isValidateByEmail = false
      }

    })
  }
  cpfValidate = param => {
    let val = param.replace(/[-.]/gi, '');
    val = val.replaceAll('_','')


    if (val.length === 11) {
      this.isValidatedBycpfservice = false

      let isCpfExistent: boolean;
      let cpfToString = param
      cpfToString = cpfToString.replaceAll('.','')
      cpfToString = cpfToString.replaceAll('-','')
      cpfToString = cpfToString.replaceAll('_','')
      let payload = { cpf: cpfToString };
      let checkCPFService: Observable<any> = this.createUserService.checkCpf(payload);
      checkCPFService.subscribe(response => {
        isCpfExistent = response.isValidCpf;
        if (isCpfExistent) {
          this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
          this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
        }
       else if(this.checkCpfValidity(val)){
        this.form.controls['cpf'].setErrors({ invalid: true });
        this.customErrorMessage = 'CPF inválido';
        return { invalid: true };
        }
         else {
          this.isValidatedBycpfservice = true
          this.form.controls['cpf'].setErrors(null);

        }
      });
    }
    else{
          this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
          this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
    }

 
  };

  checkCpfValidity(val){
    if (
      val == null ||
      val.length < 11 ||
      val == '00000000000' ||
      val == '11111111111' ||
      val == '22222222222' ||
      val == '33333333333' ||
      val == '44444444444' ||
      val == '55555555555' ||
      val == '66666666666' ||
      val == '77777777777' ||
      val == '88888888888' ||
      val == '99999999999'
    ) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
      return  true ;
    }

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
      return  true 
    }
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
       true 
    }
    // this.form.controls['cpf'].setErrors(null);
    this.customErrorMessage = '';
    return  false 
  }

  date() {
    return [
      /[0-3]/,
      /[0-9]/,
      '/',
      /[0-1]/,
      /[0-9]/,
      '/',
      /[1-2]/,
      /([0|9])/,
      /[0-9]/,
      /[0-9]/,
    ];
  }

  dateValidate(date) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    const validYear = new Date().getFullYear() - 18;

    const [d, m, y] = date.split('/');
    const day = d < 0 || d > 31 ? false : true;
    const month = m < 1 || m > 12 ? false : true;
    const year = y > validYear && parseInt(y, 10) < 1900 ? false : true;

    if (y < 1870) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    if (!day || !month || !year) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['birthDate'].setErrors(null);
    return { invalid: false };
  }

  emailValidate(param) {
    this.checkEmail(param)
 /*    if (this.form.controls.login.invalid) {
      this.form.controls['login'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['login'].setErrors(null);
    return { invalid: false }; */
  };

  phoneMask() {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  phoneValidate(phone) {
    if (!/^[(]\d{2}[)]\d{5}-\d{4}/.test(phone)) {
      this.form.controls['fone'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['fone'].setErrors(null);
    return { invalid: false };
  }

  get clients(): FormArray {
    return this.form.get('clients') as FormArray;
  }

  /**
   * Navigate to an auxiliary router outlet
   * @param {object} props
   */
  navigate(
    feature: string,
    screen: string,
    navigationType: string,
    roleName: string,
  ): void {
    this.featureService.navigate(
      feature,
      screen,
      navigationType,
      JSON.stringify({
        ...this.ctx,
        roleName,
        rootId: this.ctx.screenId,
      }),
      this.activeRoute,
    );
  }
  /**
   * Get date format from the profile
   * @param {string} temporalType
   * @param {string} datePrecision
   * @return {string} the date format
   */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(
      temporalType,
      datePrecision,
    );
  }

  validateNotSpecialCharacters(event: KeyboardEvent) {
    switch (event.keyCode) {
      case 8: // Backspace
      case 9: // Tab
      case 13: // Enter
      case 37: // Left
      case 38: // Up
      case 39: // Right
      case 40: // Down
        break;
      default:
        var regex = new RegExp('^[a-zA-Z0-9]+$');
        // var regex = new RegExp("^[a-zA-Z0-9.,/ $@()]+$");
        var key = event.key;
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
        break;
    }
  }

  closeWithoutAsk() {
    this.dialogRef.close();
  }

  close() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    this.dialog
      .open(MasterConfirmedMessageComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close(true);
        }
      });
  }

  isMasterBO() {
    return this.profileService.isMasterBO();
  }

  Salvar() {
    const user = new UserPost();
    let cpf = this.form.get('cpf').value
    if(cpf){
      cpf = cpf.replaceAll('.','')
      cpf = cpf.replaceAll('-','')
      cpf = cpf.replaceAll('_','')
    }
    
    if (this.form.value.cpf != null) user.cpf = cpf;

    user.language = this.form.value.language;
    user.login = this.form.value.login;
    user.name = this.form.value.name;
    user.userSso = this.form.value.userSso;
    user.nationality = this.form.value.nationality;
    if (this.form.value.passport != null)
      user.passport = this.form.value.passport;
    user.status = this.form.value.status;
    if (this.form3.value.investmentGroups != undefined &&
      this.form3.value.investmentGroups.length != null && this.form3.value.investmentGroups.length > 0) {
      user.investmentGroups = [];
      this.form3.value.investmentGroups.forEach(element => {
        if (element && element.id) {
          user.investmentGroups.push({ id: element.id })
        }
      });

    } else {
      user.investmentGroups = [];
    }

    user.permissionGroups = [{ id: this.form2.value.profileId }];

    let userMsg, savedMsg, oUserMsg, selectAnotherMsg: string
    this.featureService.translatorService
      .getMessage('userName')
      .subscribe(val => (userMsg = val))
    this.featureService.translatorService
      .getMessage('wasSaved')
      .subscribe(val => (savedMsg = val))
    this.featureService.translatorService
      .getMessage('o-userName')
      .subscribe(val => (oUserMsg = val))
    this.featureService.translatorService
      .getMessage('select-another-name')
      .subscribe(val => (selectAnotherMsg = val))
      let profileId = this.form2.value.profileId
      if(this.form.get('nationality').value == 'residente' && this.form.get('userSso').value) {
        let perfil = ""
        if(this.isMasterBO()) {
          perfil = "3"
        } else {
          perfil = "4"
        }
        Object.assign(user,{perfil: perfil})
        this.createUserService
      .createUserSSO(user,this.shared.userSso).toPromise()
      .then((res) => {
        // let profileId = this.form2.value.profileId
        // SSO process
        if (Number(res.result) < 100) {
          this.createUserService.postUser(user)
            .then(res => {
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showSuccess(
                  userMsg + ` "${user.name}" ` + savedMsg + "!",
                );
              }, 1500)
              this.dialogRef.close();
            }).catch(err => {
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showError(
                  userMsg + ` "${user.name}" ` + savedMsg + "!",
                );
              }, 1500)
            })
        } else {
          this.snackBarService.snackbarUtil.showError(
            res.messag,
          );
        }
      })
      .catch(err => {
        if (err.error.status === 500) {
          this.snackBarService.snackbarUtil.showWarn(
            oUserMsg + ` "${user.name}" ` + selectAnotherMsg,
          );
        }
      });
      } else {
        this.createUserService.postUser(user).then(_ => {
          this.closeWithoutAsk();
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showSuccess(
                  userMsg+` "${user.name}" `+savedMsg+"!",
                );
              }, 1500)
              this.dialogRef.close();
        }).catch(err => {
          if (err.error.status === 500) {
            this.snackBarService.snackbarUtil.showWarn(
              oUserMsg + ` "${user.name}" ` + selectAnotherMsg,
            );
          }
        });
      }

  }
  setSelectedGroups($event) {
    console.log('Event', $event);
    this.hasSelectedGroups = $event;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
